document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-sites')
    if (section) {
        const sliderEl = section.querySelector('.section-sites__slider')
        new Swiper(sliderEl, {
            slidesPerView: 1.001,
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            speed: 800,
            navigation: {
                nextEl: '.section-sites__slider-btn--next',
                prevEl: '.section-sites__slider-btn--prev',
            },
            pagination: {
                el: '.section-sites__slider-pagination',
            }, 
            effect: "creative",
            creativeEffect: {
                prev: {
                    translate: [0, '5%', 100], //([horizontal, vertical, depth])
                    opacity: 0,
                    //scale: 1.01
                },
                next: {
                    translate: [0, '-10%', -100], //([horizontal, vertical, depth])
                },
            },
            transition: {
                duration: 1800
            }
        })
    }
})